import { ChatBotMessage } from './chat-bot-message.model';

export class ChatBotModel {
  id: string;
  userId: string;
  displayName: string;
  photoURL: string;
  isAnonymous: boolean;
  feedback: string;
  createdAt: number;
  updatedAt: number;
  messages: ChatBotMessage[];
  constructor(
    id?: string,
    userId?: string,
    displayName?: string,
    photoURL?: string,
    isAnonymous?: boolean,
    feedback?: string,
    createdAt?: number,
    updatedAt?: number,
    messages?: ChatBotMessage[]
  ) {
    this.id = id || null;
    this.userId = userId || null;
    this.displayName = displayName || null;
    this.photoURL = photoURL || null;
    this.isAnonymous = isAnonymous || true;
    this.feedback = feedback || null;
    this.createdAt = createdAt || Date.now();
    this.updatedAt = updatedAt || Date.now();
    this.messages = messages || [];
  }
}
